// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function FormControlLabel(theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[600],
          fontWeight: 600,
          '& div': {
            display: 'flex'
          },
          '& .MuiCheckbox-root': {
            marginLeft: '-8px'
          }
        },
        asterisk: {
          color: theme.palette.error.main
        },
        outlined: {
          lineHeight: '0.8em',
          '&.MuiFormControlLabel-sizeSmall': {
            lineHeight: '1em'
          },
          '&.MuiFormControlLabel-shrink': {
            background: theme.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6,
            lineHeight: '1.4375em'
          }
        }
      }
    }
  };
}
